
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/testimonial",
      function () {
        return require("private-next-pages/testimonial/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/testimonial"])
      });
    }
  